var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNinos = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "87px",
    viewBox: "0 0 87 87",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-19",
    transform: "translate(-416.000000, -605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(416.000000, 605.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    fill: "#6BC33C",
    opacity: 0.74546596,
    cx: 43.5,
    cy: 43.5,
    r: 43.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4353728,25.0529837 C54.5189928,24.4375637 53.2771728,24.6814637 52.6613928,25.5980237 L47.1589728,33.7914437 C46.5550728,33.4897637 45.8743128,33.3193037 45.1532328,33.3193037 L42.1547928,33.3193037 C41.4374928,33.3193037 40.7597928,33.4881437 40.1578728,33.7869437 L34.6586928,25.5982037 C34.0429128,24.6812837 32.8012728,24.4377437 31.8847128,25.0531637 C30.9681528,25.6687637 30.7242528,26.9105837 31.3396728,27.8271437 L37.6895328,37.2825437 C37.6427328,37.6776437 37.6628928,63.9297437 37.6628928,63.9297437 C37.6628928,65.3098037 38.7815928,66.4285037 40.1616528,66.4285037 C41.5417128,66.4285037 42.6604128,65.3098037 42.6604128,63.9297437 L42.6604128,52.6849637 L44.6594928,52.6849637 L44.6594928,63.9297437 C44.6594928,65.3098037 45.7781928,66.4285037 47.1582528,66.4285037 C48.5383128,66.4285037 49.6570128,65.3098037 49.6570128,63.9297437 C49.6570128,54.2729237 49.6692528,37.7266037 49.6202928,37.2976637 L55.9804128,27.8271437 C56.5958328,26.9104037 56.3519328,25.6685837 55.4353728,25.0529837 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6599528,31.9226837 C46.3052328,31.9226837 48.4506528,29.7792437 48.4506528,27.1321637 C48.4506528,25.4511437 47.5823328,23.9726237 46.2703128,23.1179837 C46.5300528,22.9446437 46.8261528,22.7840837 47.1699528,22.6444037 C47.3335728,22.5779837 47.4437328,22.4228237 47.4520128,22.2464237 C47.4604728,22.0700237 47.3654328,21.9049637 47.2086528,21.8234237 C46.4510328,21.4299437 45.5278128,21.4218437 44.6566128,21.5888837 C44.8043928,21.3120437 44.9905128,21.0292637 45.2295528,20.7425237 C45.3425928,20.6068037 45.3665328,20.4178037 45.2907528,20.2585037 C45.2149728,20.0990237 45.0533328,19.9982237 44.8767528,20 C43.1258928,20.0200037 41.5199328,21.7949837 40.8802128,22.8564437 C40.7662728,23.0454437 40.6746528,23.2429037 40.6058928,23.4432437 C39.5451528,24.3220037 38.8692528,25.6484237 38.8692528,27.1319837 C38.8694328,29.7792437 41.0148528,31.9226837 43.6599528,31.9226837 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNinos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Ninos.7d0bfef8.svg";
export { ForwardRef as ReactComponent };